import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { isMobileOnly } from 'react-device-detect';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { PDFExport, savePDF } from '@progress/kendo-react-pdf';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Card, CardBody, Input, Label, FormGroup } from 'reactstrap';
import Notification from 'rc-notification';
import "react-datepicker/dist/react-datepicker.css";
import SmallLoader from '../../../../shared/components/SmallLoader';
import { RTLProps } from '../../../../shared/prop-types/ReducerProps';
import { getInventoryFBAForecastData, handleLoader } from '../../../../redux/actions/InventoryFBAForecastActions';
import { tableInventoryFBAForecast } from '../../helper';
import InventoryFBAForecastTable from './InventoryFBAForecastTable';

const InventoryFBAForecast = ({ dispatch, rtl }) => {
    const { t } = useTranslation('common');
    const location = useLocation();

    const { isLoading, inventoryFBAForecastData, salesChannelFilterData } = useSelector(
        ({ inventoryFBAForecastReducer, marketPlaceReducer }) =>
        ({
            salesChannelFilterData: marketPlaceReducer.salesChannel,
            inventoryFBAForecastData: inventoryFBAForecastReducer.inventoryFBAForecastData,
            isLoading: inventoryFBAForecastReducer.isLoading,
        })
    );

    const [inventoryFBAForecastDataToShow, setInventoryFBAForecastDataToShow] = useState([]);
    const [prepareStocks, setPrepareStocks] = useState(45)
    const [filterData, setFilterData] = useState({});
    const [startDate, setStartDate] = useState(new Date());

    const handleChange = (date) => {
        setStartDate(date);
    };

    const filterBasedOnFilter = (item) => {
        const filters = Object.keys(filterData);
        let flag = true
        // eslint-disable-next-line no-restricted-syntax
        for (const i of filters) {
            const filter = filterData[i];
            const filtersArray = filter?.reduce((acc, fil) => [...acc, fil?.value?.toLowerCase()], []) ?? [];
            if (filtersArray?.length && !filtersArray.includes(item?.[i]?.toLowerCase())) {
                flag = false
            }
        }
        return flag
    }

    const container = React.useRef(null);
  const exportToPDF = () => {
    // console.log('Hello')
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'PDF loading......',
        duration: 5,
        style: {top: 120, fontWeight: "bold"},
        maxCount: 10
      });
    });
    const dvTb = document.getElementById('dvTable');
    dvTb.style.display = "none";  
    const element = container.current || document.body;
    
    savePDF(element, {
      paperSize: "auto",
      Header: "test",
      margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
     // margin: "2cm",
     // forcePageBreak: ".page-break",
    //   landscape: true,
    //  multiPage: true,
      fileName: `FBA Inventory Forecast Report ${new Date().getFullYear()}`,
    })
    dvTb.style.display = "block";  
  }

    const callApi = () => {
        dispatch(handleLoader(true))
        dispatch(getInventoryFBAForecastData({ date: moment(startDate).format('YYYY-MM-DD') }));
    }

    const handleApplyDate = () => {
        callApi()
    }

    useEffect(() => {
        dispatch(handleLoader(true));
        callApi();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setInventoryFBAForecastDataToShow(inventoryFBAForecastData?.modal?.data || []);
    }, [inventoryFBAForecastData]);

    useEffect(() => {
        const OptChennel = 'salesChannel';
        setFilterData({ ...filterData, [OptChennel]: salesChannelFilterData });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [salesChannelFilterData]);

    const inventoryFBAForecastDataToShowForDatesSelected = inventoryFBAForecastDataToShow?.filter(item =>
        filterBasedOnFilter(item));

    return (
        <Container className="dashboard">
            <Row className="monthly-subscription-order">
                <Col sm="12">
                    <Card className="pb-3">
                        <CardBody className="min-w-50 p-3">
                            <div className="card__title mb-2">
                                <h5 className="bold-text card__title-center">FBA Inventory Forecast </h5>
                            </div>
                            <Row className="align-items-center">
                                {/* <Col md="2">
                                    <div className="form__form-group mb-0">
                                        <span className="form__form-group-label">Country</span>
                                        <div className="form__form-group-field">
                                            <Select
                                                value={filterData?.country || []}
                                                options={filtersObj?.filterData?.map(countr =>
                                                    ({ label: countr.longValue, value: countr.key }))}
                                                clearable={false}
                                                placeholder="Select Country"
                                                className="select_filter"
                                                onChange={value => setFilterData({
                                                    ...filterData,
                                                    [filtersObj?.applyToColumn]: value
                                                })}
                                                classNamePrefix="react-select"
                                                isMulti
                                            />
                                        </div>
                                    </div>
                                </Col> */}
                                <Col md="2">
                                    <div className="form__form-group mb-0">
                                        <span className="form__form-group-label">Prepare stocks [ * ] days</span>
                                        <div className="form__form-group-field">
                                            <Input type="number"
                                                onChange={({ target }) => setPrepareStocks(target.value)}
                                                name="prepareStocks" id="prepareStocks"
                                                value={prepareStocks}
                                                placeholder="Prepare stocks [ 45 ] days" />
                                        </div>
                                    </div>
                                </Col>
                                <Col md="10">
                                    <Row className="align-items-center">
                                        <Col sm="3">
                                            <div className="form__form-group mb-0">
                                                <span className="form__form-group-label">Date</span>
                                                <div className="form__form-group-field">
                                                    <div className="date-picker">
                                                        <DatePicker
                                                            className="form__form-group-datepicker"
                                                            selected={moment(startDate).toDate()}
                                                            onChange={handleChange}
                                                            dateFormat="MM/dd/yyyy"
                                                            dropDownMode="select"
                                                            popperPlacement="center"
                                                            withPortal={isMobileOnly}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                        </Col>
                                        <Col sm="9" style={{ top: '10px' }}>
                                            <button className="btn btn-sm btn-primary apply-date-button"
                                                type="button" onClick={handleApplyDate}>
                                                Apply</button>
                                                <button className="btn btn-sm btn-primary
                                             apply-date-button"  type="button"
                                             title='Export to pdf' disabled={isLoading}
                                    onClick={exportToPDF}>Export PDF</button>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <div id="divToPrint" ref={container}>
            <Card className="pb-3">
                <CardBody className="">
                    <Row className="show-sales-region">
                        <Col md="12">
                            <Card>
                                <CardBody className="p-0">
                                    <div className="top-location" style={{ minHeight: '400' }}>
                                        <div >
                                            {isLoading ? <div style={{ minHeight: '200px' }}
                                                className="row align-items-center justify-content-center">
                                                <SmallLoader loading={isLoading} />
                                            </div>
                                                : <InventoryFBAForecastTable
                                                    prepareStocks={prepareStocks}
                                                    tableHeaderData={tableInventoryFBAForecast(prepareStocks)}
                                                    data={inventoryFBAForecastDataToShowForDatesSelected} />}
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
            </div>
        </Container>
    );
};

InventoryFBAForecast.propTypes = {
    dispatch: PropTypes.func.isRequired,
    rtl: RTLProps.isRequired,
};

export default connect(state => ({
    rtl: state.rtl,
}))(InventoryFBAForecast);
